<template>
  <DeprecationGate v-if="showDeprecationGate" />
  <template v-else>
    <Loader />
    <router-view />
    <Notification></Notification>
    <HelpPopup />
  </template>
</template>

<script>
import TheNotifications from '@/components/UI/Notification/TheNotifications.vue';
import BaseLoader from '@/components/UI/Loader/BaseLoader.vue';
import HelpPopup from '@/components/Help/HelpPopup.vue';
import DeprecationGate from '@/views/DeprecationGate.vue';
import { useEntitiesStore } from '@/store/entities/entitiesStore';
import { useLayoutStore } from '@/store/layout/layoutStore';
import { useNotificationStore } from '@/store/notifications/notificationStore';
import { Capacitor } from '@capacitor/core';
import { LiveUpdate } from '@capawesome/capacitor-live-update';
import { useOrderStore } from '@/store/order/orderStore';
import { isCutoverReached } from '@/utils/deprecationGate/cutover';
import { useDeprecationGateStore } from '@/store/deprecationGate/deprecationGateStore';

export default {
  name: 'App',
  components: {
    Notification: TheNotifications,
    Loader: BaseLoader,
    HelpPopup,
    DeprecationGate,
  },
  data() {
    return {
      entitiesStore: useEntitiesStore(),
      layoutStore: useLayoutStore(),
      notificationStore: useNotificationStore(),
      deprecationGateStore: useDeprecationGateStore(),
      onLine: navigator.onLine,
    };
  },
  computed: {
    businessEntities() {
      return this.entitiesStore.businessEntities;
    },
    showDeprecationGate() {
      if (Capacitor.isNativePlatform()) {
        return (
          isCutoverReached(new Date()) &&
          !this.deprecationGateStore.fallbackConfirmed
        );
      }
      // bxApp v1 is retired on the web (PHX-2644); only the local dev server
      // (npm run serve) still renders it, e.g. to reproduce issues.
      return import.meta.env.MODE !== 'development';
    },
  },
  watch: {
    onLine(isOnline) {
      this.layoutStore.setOnlineState(isOnline);
      if (isOnline) {
        const orderStore = useOrderStore();
        if (
          orderStore.activeOrder.changes?.unsavedTransactionCount > 10 &&
          !orderStore.isAutoSaving
        ) {
          orderStore.triggerAutoSave();
        }
      }
    },
  },
  async mounted() {
    if (Capacitor.isNativePlatform()) {
      await LiveUpdate.ready();
    }

    window.addEventListener('online', this.handleOnline);
    window.addEventListener('offline', this.handleOffline);
    const layoutStore = useLayoutStore();

    if (localStorage.getItem('isDarkMode') === 'true') {
      layoutStore.activateDarkMode();
      return;
    }

    if (localStorage.getItem('isDarkMode') === 'false') {
      layoutStore.deactivateDarkMode();
      return;
    }

    if (window.matchMedia('(prefers-color-scheme: dark)').matches) {
      layoutStore.activateDarkMode();
    }
  },
  methods: {
    handleOnline() {
      this.onLine = true;
    },
    handleOffline() {
      this.onLine = false;
    },
  },
};
</script>
